export const WEATHER_BOARD_ID = 'weatherBoard';
